import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../widgets/Icon/index';

const PlaylistPreviewLink = ({ playlist, ticker, icon, label, color }) => {
  if (!playlist) {
    return (
      <span style={{ marginLeft: '0px', alignSelf: 'center', marginTop: '0px' }} className="button secondary disabled preview-link">
        {icon && <Icon title="Preview" name="eye" size="1.1rem" />} {label}
      </span>
    );
  }

  const previewLink = `/preview/${playlist}/${ticker ? `${ticker}/` : ''}`;

  return (
    <React.Fragment>
      <Link className="hide-for-mobile" style={{ marginLeft: '0px', alignSelf: 'center', marginTop: '0px' }} to={previewLink} className={classnames({ 'button secondary': !icon }, 'preview-link hide-for-mobile')}>
        {icon && <Icon color={{ color }} title="Preview" name="eye" size="1.1rem" />}
        {label}
      </Link>
      <Link className="" style={{ marginLeft: '0px', alignSelf: 'center', marginTop: '0px', fontSize: '0.8rem' }} to={previewLink} className={classnames({ 'hide-for-desktop': !icon }, ' preview-link hide-for-desktop')}>
        {icon && <Icon color={{ color }} title="Preview" name="eye" size="1.1rem" />}
        {label}
      </Link>
    </React.Fragment>
  );
};

PlaylistPreviewLink.propTypes = {
  playlist: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ticker: PropTypes.number,
  icon: PropTypes.bool,
  label: PropTypes.string,
};

PlaylistPreviewLink.defaultProps = {
  ticker: null,
  icon: false,
  label: null,
};

export default PlaylistPreviewLink;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PlaylistPreviewLink/index.js